import React, { useEffect, useState } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import StayoverButton from "../../../components/admin/usable/StayoverButton";
import { useClientAuth } from "../../../utils/useAuth";
import {
  getHotels,
  getRooms,
  sendStayoverRequest,
} from "../../../api/client/stayoverapi";
import toast from "react-hot-toast";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
function formatDate(date) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Dhaka",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}
const RequestStayover = ({ data = {} }) => {
  const { company } = useClientAuth();
  const [open, setOpen] = useState(false);
  const [HotelData, setHotelData] = useState([]);
  const [RoomData, setRoomData] = useState([]);
  const [SelectedHotel, setSelectedHotel] = useState(null);
  const [SelectedRoom, setSelectedRoom] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [FormData, setFormData] = useState([]);

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const [CheckIn, setCheckIn] = useState(formatDate(today));
  const [CheckOut, setCheckOut] = useState(formatDate(tomorrow));
  useEffect(() => {
    getHotels(setHotelData, setIsLoading, company?.id);
  }, [company?.id]);

  const handleHotelChange = (e) => {
    const hotelId = e.target.value;

    setSelectedHotel(hotelId);

    if (!hotelId) {
      toast.error("Please select a hotel");
      setRoomData([]);
      return;
    }

    getRooms(setRoomData, setIsLoading, hotelId, company?.id);
  };
  const handleRoomChange = (e) => {
    const roomId = e.target.value;

    const room = RoomData.find((item) => item.id.toString() === roomId);

    if (!room) return;

    setSelectedRoom((prev) => {
      const exists = prev.find((r) => r.id === room.id);

      let updatedRooms;

      if (exists) {
        updatedRooms = prev.filter((r) => r.id !== room.id);
      } else {
        updatedRooms = [...prev, room];
      }

      const formattedData = updatedRooms.map((r) => {
        const price = r.actualPrice || 0;
        const discount = r.discount || 0;

        const discountedPrice = price - (price * discount) / 100;
        const taxAmount = (discountedPrice * (r.tax || 0)) / 100;

        return {
          hotelId: SelectedHotel,
          roomId: r.id,
          orderId: data?.id || "",
          checkIn: CheckIn,
          checkOut: CheckOut,
          actualPrice: price,
          discount: discount,
          discountedPrice: discountedPrice,
          serviceCharge: r.tax || 0,
          serviceChargeAmount: taxAmount,
          paymentStatus: "Pending",
          paymentNature: "Online",
          requestedBy: "Hotel",
          isApproved: 1,
        };
      });

      setFormData(formattedData);

      return updatedRooms;
    });
  };
  const nights =
    CheckIn && CheckOut
      ? (new Date(CheckOut) - new Date(CheckIn)) / (1000 * 60 * 60 * 24)
      : 0;
  const grandTotal =
    SelectedRoom?.length > 0
      ? SelectedRoom.reduce((acc, room) => {
          const price = room?.actualPrice || 0;
          const discount = room?.discount || 0;
          const tax = room?.tax || 0;

          const discountedPrice = price - (price * discount) / 100;
          const taxAmount = (discountedPrice * tax) / 100;
          const total = discountedPrice + taxAmount;

          return acc + total * nights;
        }, 0)
      : 0;
  useEffect(() => {
    if (!SelectedRoom.length) return;

    const formattedData = SelectedRoom.map((r) => {
      const price = r.actualPrice || 0;
      const discount = r.discount || 0;

      const discountedPrice = price - (price * discount) / 100;
      const taxAmount = (discountedPrice * (r.tax || 0)) / 100;

      return {
        hotelId: SelectedHotel,
        roomId: r.id,
        orderId: data?.id || "",
        checkIn: CheckIn,
        checkOut: CheckOut,
        actualPrice: price * nights,
        discount: discount,
        discountedPrice: discountedPrice * nights,
        serviceCharge: r.tax || 0,
        serviceChargeAmount: taxAmount * nights,
        paymentStatus: "Pending",
        paymentNature: "Offline",
        requestedBy: "Hotel",
        isApproved: 1,
      };
    });

    setFormData(formattedData);
  }, [SelectedRoom, CheckIn, CheckOut, SelectedHotel, nights, data?.id]);
  const handleSubmitRequest = () => {
    if (FormData.length === 0) {
      toast.error("Please select at least one room");
      return;
    }
    sendStayoverRequest(FormData, setIsLoading);
  };
  console.log(FormData);
  return (
    <>
      <StayoverButton onClick={() => setOpen(true)} text="Request Stayover" />
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        <Sheet
          variant="outlined"
          sx={{ borderRadius: "md", p: 3, boxShadow: "lg" }}
          className="min-w-full lg:min-w-[900px] h-[600px] overflow-y-auto lg:h-fit scrollbar-hide"
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            {data?.invoiceId} | Request Stayover For{" "}
            {nights ? `${nights} Nights` : ""}
          </Typography>
          <div className="space-y-3">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
              <div>
                <select
                  name=""
                  id=""
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  onChange={handleHotelChange}
                >
                  <option value="">Select Hotel</option>
                  {HotelData.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.hotelName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  name=""
                  id=""
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  onChange={handleRoomChange}
                >
                  <option value="">Select Room</option>
                  {RoomData.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.roomName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div>
              <div className="py-3 w-full overflow-x-auto">
                <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Room
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Actual Price (BDT)
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Discounted Price (BDT)
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Service Charge (BDT)
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                        Total (BDT)
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200">
                    {SelectedRoom?.length > 0 ? (
                      SelectedRoom.map((room) => {
                        const price = room?.actualPrice || 0;
                        const discount = room?.discount || 0;
                        const tax = room?.tax || 0;

                        const discountedPrice =
                          price - (price * discount) / 100;
                        const taxAmount = (discountedPrice * tax) / 100;
                        const total = discountedPrice + taxAmount;

                        return (
                          <tr key={room.id} className="hover:bg-gray-50">
                            <td className="px-4 py-3 text-sm text-gray-700">
                              {room.roomName}
                            </td>

                            <td className="px-4 py-3 text-sm">
                              {price.toFixed(0) * nights}
                            </td>

                            <td className="px-4 py-3 text-sm text-gray-700">
                              {discountedPrice.toFixed(0) * nights} (
                              {room.discount}%)
                            </td>

                            <td className="px-4 py-3 text-sm">
                              {taxAmount.toFixed(0) * nights} ({room.tax}%)
                            </td>

                            <td className="px-4 py-3 text-sm text-center">
                              {total.toFixed(0) * nights}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center py-4 text-gray-500"
                        >
                          No room selected
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td
                        colSpan="4"
                        className="px-4 py-3 text-sm text-end font-semibold"
                      >
                        Total Amount
                      </td>
                      <td className="px-4 py-3 text-sm text-center font-semibold">
                        {grandTotal.toFixed(0) || 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
              <div>
                <label htmlFor="">Check In</label>
                <input
                  type="date"
                  className="w-full border rounded-md focus:outline-none px-2 py-1"
                  onChange={(e) => setCheckIn(e.target.value)}
                  value={CheckIn}
                />
              </div>
              <div>
                <label htmlFor="">Check Out</label>
                <input
                  type="date"
                  className="w-full border rounded-md focus:outline-none px-2 py-1"
                  onChange={(e) => setCheckOut(e.target.value)}
                  value={CheckOut}
                />
              </div>
            </div>
            <div className="text-center py-3">
              <small>
                This is a request for a stayover at {data?.hotelName}. <br />{" "}
                Payment will be collected by the hotel directly. Please contact
                Dhoorbin for any inquiries regarding this stayover request.
              </small>
            </div>
            <div className="flex justify-end items-center gap-3">
              <AddButton
                onClick={handleSubmitRequest}
                text={`Send Request${IsLoading ? "..." : ""}`}
              />
              <CancelButton onClick={() => setOpen(false)} text={"Cancel"} />
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default RequestStayover;
